/* eslint-disable import/no-unresolved */
import React, { useContext, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import BackgroundDashboard from 'assets/images/dashboard-bg.svg';
import { useHistory, useLocation } from 'react-router-dom';
import { LoyaltyContext } from '../../../../contexts/loyalty/context';

const MainLayout = ({ children = null }) => {
  const history = useHistory();
  const closePromotionBannerInfo = () => history.push('/dashboard/card/details');

  const { state, openScreen } = useContext(LoyaltyContext);
  const { state: locationState } = useLocation();

  useEffect(() => {
    if (!locationState?.initScreen) {
      history.push('/dashboard/card/details');
    } else {
      openScreen(locationState?.initScreen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderedComponent = useMemo(() => {
    if (Array.isArray(children)) {
      return children?.filter((child) => child.props.keyName === state?.currentScreen);
    }
    return [children]?.filter((child) => child.props.keyName === state?.currentScreen);
  }, [children, state?.currentScreen]);

  const isDashboardBackgroundNeeded = useMemo(() => {
    if (['', '1inch'].includes(process.env.REACT_APP_FLAVOR)) {
      return true;
    }
    return false;
  }, []);

  return (
    <div
      className="d-flex flex-row h-100 main-layout position-relative"
      style={{
        ...(isDashboardBackgroundNeeded
          ? { backgroundImage: `url(${BackgroundDashboard})`, backgroundRepeat: 'no-repeat' }
          : {}),
      }}>
      <div
        className="position-absolute loyalty-close-btn"
        onClick={closePromotionBannerInfo}
        onKeyDown={closePromotionBannerInfo}
        role="button"
        tabIndex={-1}>
        <i
          className="close-btn cursor-pointer text-hover icon icon-close-other text-dark text-f4"
          aria-label="Close"
        />
      </div>

      <div className="d-flex flex-row flex-fill justify-content-center loyalty-main-container">
        <div className="w-100 position-relative loyalty-main-container-inner">
          {renderedComponent}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;

MainLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
